import { render, staticRenderFns } from "./PanelConsultant.vue?vue&type=template&id=28d4f3e4&"
import script from "./PanelConsultant.vue?vue&type=script&lang=js&"
export * from "./PanelConsultant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports